import { render, staticRenderFns } from "./DistribuzionePagamenti.vue?vue&type=template&id=5b2fe7a8"
import script from "./DistribuzionePagamenti.vue?vue&type=script&lang=js"
export * from "./DistribuzionePagamenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports